const SUB_NUMBER_PAD_LENGTH = 2 // AS400 constraint — matches Chart of Accounts MAX_SUB_NUMBER_LENGTH

export interface FormatGlAccountOptionLabelParams {
  number: number | string
  subNumber?: number | string | null
  title: string
}

const formatNumber = ({
  number,
  subNumber,
}: Pick<FormatGlAccountOptionLabelParams, "number" | "subNumber">): string => {
  if (subNumber === null || subNumber === undefined) {
    return String(number)
  }

  return `${number}-${subNumber.toString().padStart(SUB_NUMBER_PAD_LENGTH, "0")}`
}

export const formatGlAccountOptionLabel = (account: FormatGlAccountOptionLabelParams, isInactive: boolean): string => {
  const baseLabel = `${formatNumber(account)} - ${account.title}`

  return isInactive ? `${baseLabel} (Inactive)` : baseLabel
}
